import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t-2 border-foreground py-6 px-4">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        
        {/* Social Media Links Section */}
        <div className="flex gap-3 mb-5">
          <SocialLink href="https://instagram.com/dmflio" icon={<Instagram />} label="Instagram" />
          <SocialLink href="https://www.facebook.com/profile.php?id=61560681520544" icon={<Facebook />} label="Facebook" />
        </div>

        {/* Primary Links */}
        <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 font-black uppercase text-[11px] tracking-widest mb-5">
          <Link to="/about-us" className="hover:text-primary transition-colors">About Us</Link>
          <Link to="/contact-us" className="hover:text-primary transition-colors">Contact Us</Link>
          <Link to="/privacy-policy" className="hover:text-primary transition-colors">Privacy Policy</Link>
          <Link to="/terms-and-conditions" className="hover:text-primary transition-colors">Terms</Link>
          <Link to="/refund-policy" className="hover:text-primary transition-colors">Refund Policy</Link>
          {/* Added Data Deletion Link below */}
          <Link to="/data-deletion" className="hover:text-primary transition-colors text-primary underline decoration-2 underline-offset-4">Data Deletion</Link>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="font-black uppercase text-[10px] tracking-widest text-muted-foreground">
            &copy; 2026 EXEMPLORA CONSUMER PRIVATE LIMITED
          </p>
        </div>
      </div>
    </footer>
  );
}

// Reusable Social Icon Component
function SocialLink({ href, icon, label }) {
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer"
      aria-label={label}
      className="w-9 h-9 bg-white border-2 border-foreground flex items-center justify-center shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:shadow-none hover:translate-x-1 hover:translate-y-1 hover:bg-primary hover:text-white transition-all [&>svg]:w-4 [&>svg]:h-4"
    >
      {icon}
    </a>
  );
}
